module.exports = __webpack_public_path__ + "img/our4.e16eb751.svg";